import React from "react";
import { useHistory } from "react-router";
import * as MUI from "@material-ui/core";
import type { FC } from "react";
import { useStyles } from "./RecentlyCard.styles";
import type { IRecentlyCardProps } from "./RecentlyCard.types";

export const RecentlyCard: FC<IRecentlyCardProps> = (props) => {
  const { children, to, openInNewTab } = props;
  const history = useHistory();
  const classes = useStyles(props);
  const [mediaNode, titleNode, dateNode] = children;

  const handlerClick = () => {
    if (openInNewTab) {
      window.open(to, "_blank");
    } else {
      history.push(to);
    }
  };

  return (
    <MUI.Card className={classes.card}>
      <MUI.CardActionArea className={classes.actionArea} onClick={handlerClick} component="a">
        {mediaNode}
        <MUI.CardContent className={classes.content}>{[titleNode, dateNode]}</MUI.CardContent>
      </MUI.CardActionArea>
    </MUI.Card>
  );
};

export default RecentlyCard;
